/*
  DM — header (sections/dm-header.liquid).
  - Sticky: on phones the main row (<header>) sticks; on desktop the nav row
    (.site-header) sticks while the rows above scroll away. With "smart" the sticky row
    slides away on scroll down and returns on scroll up. Once the main row has scrolled
    out, the nav row shows compact search + cart (.is-stuck).
  - Nav panels (desktop): "Shop by Car" and any short list open on hover after 120ms
    (mouse/trackpad only); click, Enter or Space toggles and pins; ArrowDown enters the
    panel; Escape closes and returns focus. Other nav items are plain links.
  - Shop by Car panel: car families are tabs. Hovering (after 90ms, so a diagonal move to
    the cars column doesn't switch), focusing or arrow keys show one family's cars; the
    family of the visitor's last car is shown first.
  - Drawer (phone/tablet): modal <dialog> with drill-down panels.
  - Search: modal <dialog>; car pages matched locally first, then Shopify predictive
    results; "/" opens it from anywhere; Enter submits to /search.
  - Recent cars: visiting a car page from the Cars menu remembers it (last 3, 180 days).
    "Last viewed" becomes "Your" once the same car was visited on two different days.
*/
(function () {
  'use strict';

  var CARS_KEY = 'dm:cars';
  var desktopMQ = window.matchMedia('(min-width: 1024px)');
  var hoverMQ = window.matchMedia('(hover: hover) and (pointer: fine)');

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  function readCars() {
    try { return JSON.parse(localStorage.getItem(CARS_KEY) || '[]') || []; } catch (e) { return []; }
  }
  function writeCars(list) {
    try { localStorage.setItem(CARS_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function carPages() {
    var el = $('[data-dm-car-pages]');
    try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; }
  }

  /* ---------------- sticky ---------------- */
  function initSticky(header, navrow) {
    var mode = header.getAttribute('data-sticky') || 'smart';
    if (mode === 'off') {
      header.classList.add('dm-hdr--static');
      if (navrow) navrow.classList.add('dm-hdr--static');
      return;
    }
    var lastY = window.scrollY;
    var ticking = false;
    function active() { return desktopMQ.matches && navrow ? navrow : header; }
    function update() {
      ticking = false;
      var y = window.scrollY;
      var el = active();
      var other = el === header ? navrow : header;
      if (other) other.classList.remove('is-hidden');
      var mainBottom = header.getBoundingClientRect().bottom;
      if (navrow) navrow.classList.toggle('is-stuck', desktopMQ.matches && mainBottom <= 0);
      el.classList.toggle('is-scrolled', y > 8);
      if (mode === 'smart') {
        var open = document.querySelector('[data-dm-mega-trigger][aria-expanded="true"]');
        var threshold = (el === header ? header.offsetHeight : header.offsetHeight + header.getBoundingClientRect().top + window.scrollY) + 80;
        if (y > threshold && y > lastY + 6 && !open) el.classList.add('is-hidden');
        else if (y < lastY - 6 || y <= threshold - 80) el.classList.remove('is-hidden');
        if (el.classList.contains('is-hidden')) el.setAttribute('inert', ''); else el.removeAttribute('inert');
      }
      lastY = y;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    desktopMQ.addEventListener('change', update);
    // Landing-page anchor navs measure the sticky header on scroll events. Once a slide
    // has finished, nudge them to measure again so they never keep a mid-slide offset.
    [header, navrow].forEach(function (el) {
      if (!el) return;
      el.addEventListener('transitionend', function (e) {
        if (e.target === el && e.propertyName === 'transform') {
          requestAnimationFrame(function () { window.dispatchEvent(new Event('scroll')); });
        }
      });
    });
    update();
  }

  /* ---------------- mega menus ---------------- */
  // Used for the nav row and for the top row (support menu items with children).
  function initMega(navrow) {
    if (!navrow) return;
    var triggers = $all('[data-dm-mega-trigger]', navrow);
    var openTimer = null;
    var closeTimer = null;
    var current = null;
    var pinned = false;

    function panelFor(t) { return document.getElementById(t.getAttribute('aria-controls')); }
    function close(t, restoreFocus) {
      if (!t) return;
      t.setAttribute('aria-expanded', 'false');
      var p = panelFor(t);
      if (p) p.hidden = true;
      if (current === t) { current = null; pinned = false; }
      document.documentElement.classList.toggle('dm-mega-open', !!current);
      if (restoreFocus) t.focus();
    }
    function open(t, pin) {
      if (current && current !== t) close(current);
      t.setAttribute('aria-expanded', 'true');
      var p = panelFor(t);
      if (p) p.hidden = false;
      current = t;
      pinned = !!pin;
      document.documentElement.classList.add('dm-mega-open');
      navrow.classList.remove('is-hidden');
      navrow.removeAttribute('inert');
    }

    triggers.forEach(function (t) {
      var item = t.closest('[data-dm-nav-item]');
      t.addEventListener('click', function (e) {
        e.preventDefault();
        if (t.getAttribute('aria-expanded') === 'true' && pinned) close(t);
        else open(t, true);
      });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          if (t.getAttribute('aria-expanded') !== 'true') open(t, true);
          var p = panelFor(t);
          var first = p && (p.querySelector('[role="tab"][aria-selected="true"]') || p.querySelector('a, button'));
          if (first) first.focus();
        }
      });
      if (!item) return;
      item.addEventListener('mouseenter', function () {
        if (!hoverMQ.matches || !desktopMQ.matches) return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        if (pinned && current !== t) return;
        openTimer = setTimeout(function () { open(t, false); }, current ? 0 : 120);
      });
      item.addEventListener('mouseleave', function () {
        if (!hoverMQ.matches || !desktopMQ.matches) return;
        clearTimeout(openTimer);
        if (pinned) return;
        closeTimer = setTimeout(function () { if (current === t) close(t); }, 280);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && current) { e.preventDefault(); close(current, true); }
    });
    document.addEventListener('click', function (e) {
      if (current && !navrow.contains(e.target)) close(current);
    });
    navrow.addEventListener('focusout', function (e) {
      if (current && e.relatedTarget && !navrow.contains(e.relatedTarget)) close(current);
    });
    var scrollStart = null;
    window.addEventListener('scroll', function () {
      if (!current || pinned) { scrollStart = null; return; }
      if (scrollStart === null) scrollStart = window.scrollY;
      if (Math.abs(window.scrollY - scrollStart) > 64) { close(current); scrollStart = null; }
    }, { passive: true });
    window.addEventListener('pageshow', function () { if (current) close(current); });
    desktopMQ.addEventListener('change', function () { if (current) close(current); });
  }

  /* ---------------- Shop by Car panel ---------------- */
  function initCarPanels() {
    $all('[data-dm-cars]').forEach(function (panel) {
      var tabs = $all('[role="tab"]', panel);
      var hoverTimer = null;
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var list = document.getElementById(t.getAttribute('aria-controls'));
          if (list) list.hidden = !on;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('focus', function () { select(t); });
        t.addEventListener('mouseenter', function () {
          if (!hoverMQ.matches) return;
          clearTimeout(hoverTimer);
          hoverTimer = setTimeout(function () { select(t); }, 90);
        });
        t.addEventListener('mouseleave', function () { clearTimeout(hoverTimer); });
        t.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowDown') next = tabs[(i + 1) % tabs.length];
          else if (e.key === 'ArrowUp') next = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') next = tabs[0];
          else if (e.key === 'End') next = tabs[tabs.length - 1];
          else if (e.key === 'ArrowRight') {
            var list = document.getElementById(t.getAttribute('aria-controls'));
            var firstCar = list && list.querySelector('a');
            if (firstCar) { e.preventDefault(); firstCar.focus(); }
            return;
          }
          if (next) { e.preventDefault(); select(next, true); }
        });
      });
      $all('[role="tabpanel"]', panel).forEach(function (list) {
        list.addEventListener('keydown', function (e) {
          var links = $all('a', list);
          var at = links.indexOf(document.activeElement);
          if (at === -1) return;
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            var tab = document.getElementById(list.getAttribute('aria-labelledby'));
            if (tab) tab.focus();
          } else if (e.key === 'ArrowDown') { e.preventDefault(); (links[at + 1] || links[0]).focus(); }
          else if (e.key === 'ArrowUp') { e.preventDefault(); (links[at - 1] || links[links.length - 1]).focus(); }
        });
      });
      panel.__dmSelectFamily = function (title) {
        var tab = tabs.filter(function (t) { return t.getAttribute('data-dm-fam') === title; })[0];
        if (tab) select(tab);
      };
    });
  }

  /* ---------------- drawer ---------------- */
  function initDrawer() {
    var drawer = $('[data-dm-drawer]');
    var openers = $all('[data-dm-drawer-open]');
    if (!drawer || typeof drawer.showModal !== 'function') return;
    var stack = [];
    var lastGo = [];

    function showPanel(id, back) {
      $all('[data-dm-panel]', drawer).forEach(function (p) {
        var on = p.getAttribute('data-dm-panel') === id;
        p.hidden = !on;
        p.classList.toggle('is-back', !!back && on);
        if (on) p.scrollTop = 0;
      });
      var panel = $('[data-dm-panel="' + id + '"]', drawer);
      if (!panel) return;
      if (back && lastGo.length) {
        var returnTo = lastGo.pop();
        if (returnTo) returnTo.focus({ preventScroll: true });
      } else {
        var heading = panel.querySelector('[data-dm-panel-title]');
        if (heading) heading.focus({ preventScroll: true });
      }
    }
    openers.forEach(function (b) {
      b.addEventListener('click', function () {
        stack = ['root'];
        lastGo = [];
        showPanel('root');
        drawer.showModal();
        document.documentElement.classList.add('dm-drawer-open');
        openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
      });
    });
    drawer.addEventListener('close', function () {
      document.documentElement.classList.remove('dm-drawer-open');
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
    });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || e.target.closest('[data-dm-drawer-close]')) { drawer.close(); return; }
      var go = e.target.closest('[data-dm-panel-go]');
      if (go) { e.preventDefault(); lastGo.push(go); var id = go.getAttribute('data-dm-panel-go'); stack.push(id); showPanel(id); return; }
      var back = e.target.closest('[data-dm-panel-back]');
      if (back) { e.preventDefault(); stack.pop(); showPanel(stack[stack.length - 1] || 'root', true); return; }
      if (e.target.closest('[data-dm-search-open]')) drawer.close();
    });
    desktopMQ.addEventListener('change', function (e) { if (e.matches && drawer.open) drawer.close(); });
  }

  /* ---------------- search ---------------- */
  function initSearch() {
    var dialog = $('[data-dm-search]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var input = $('[data-dm-search-input]', dialog);
    var results = $('[data-dm-search-results]', dialog);
    var idle = $('[data-dm-search-idle]', dialog);
    var allLink = $('[data-dm-search-all]', dialog);
    var status = $('[data-dm-search-status]', dialog);
    var cars = carPages().map(function (c) { c.n = norm(c.t); return c; });
    var timer = null;
    var controller = null;
    var lastQuery = '';

    function openSearch(e) {
      if (e) e.preventDefault();
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('dm-search-open');
      input.focus();
      input.select();
    }
    $all('[data-dm-search-open]').forEach(function (b) { b.addEventListener('click', openSearch); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
      var tag = (e.target && e.target.tagName) || '';
      if (/INPUT|TEXTAREA|SELECT/.test(tag) || (e.target && e.target.isContentEditable)) return;
      openSearch(e);
    });
    dialog.addEventListener('close', function () { document.documentElement.classList.remove('dm-search-open'); });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || e.target.closest('[data-dm-search-close]')) { dialog.close(); return; }
      var chip = e.target.closest('[data-dm-search-term]');
      if (chip) { e.preventDefault(); input.value = chip.getAttribute('data-dm-search-term'); run(); input.focus(); }
    });

    function matchCars(q) {
      var qn = norm(q);
      if (qn.length < 3) return [];
      var hits = [];
      cars.forEach(function (c) {
        if (qn.indexOf(c.n) !== -1) hits.push({ c: c, s: 2 + c.n.length / 100 });
        else if (c.n.indexOf(qn) !== -1) hits.push({ c: c, s: 1 });
      });
      hits.sort(function (a, b) { return b.s - a.s; });
      return hits.slice(0, 4).map(function (h) { return h.c; });
    }

    function render(data, q) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [];
      var collections = r.collections || [];
      var pages = (r.pages || []).filter(function (p) { return !cars.some(function (c) { return c.u === p.url; }); }).concat(r.articles || []);
      var carHits = matchCars(q);
      var html = '';
      if (carHits.length) {
        html += '<div class="dm-search__group"><p class="dm-search__label">Your car</p><ul class="dm-search__chips" role="list">' +
          carHits.map(function (c) { return '<li><a class="dm-search__chip dm-search__chip--car" href="' + escapeHtml(c.u) + '">' + escapeHtml(c.t) + ' parts</a></li>'; }).join('') + '</ul></div>';
      }
      if (collections.length) {
        html += '<div class="dm-search__group"><p class="dm-search__label">Categories</p><ul class="dm-search__chips" role="list">' +
          collections.slice(0, 6).map(function (c) { return '<li><a class="dm-search__chip" href="' + escapeHtml(c.url) + '">' + escapeHtml(c.title) + '</a></li>'; }).join('') + '</ul></div>';
      }
      if (products.length) {
        html += '<div class="dm-search__group"><p class="dm-search__label">Parts</p><ul class="dm-search__products" role="list">' +
          products.slice(0, 6).map(function (p) {
            var img = (p.featured_image && p.featured_image.url) || p.image;
            var thumb = img ? '<img src="' + escapeHtml(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="56" height="56" loading="lazy">' : '';
            return '<li><a class="dm-search__product" href="' + escapeHtml(p.url) + '"><span class="dm-search__thumb">' + thumb + '</span><span class="dm-search__ptitle">' + escapeHtml(p.title) + '</span></a></li>';
          }).join('') + '</ul></div>';
      }
      if (pages.length) {
        html += '<div class="dm-search__group"><p class="dm-search__label">Guides &amp; help</p><ul class="dm-search__links" role="list">' +
          pages.slice(0, 5).map(function (p) { return '<li><a href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a></li>'; }).join('') + '</ul></div>';
      }
      if (!html) html = '<p class="dm-search__empty">No quick matches for “' + escapeHtml(q) + '”. Press Enter to search everything, or ask our team.</p>';
      results.innerHTML = html;
      results.hidden = false;
      if (idle) idle.hidden = true;
      if (status) status.textContent = (carHits.length + products.length + collections.length + pages.length) + ' suggestions';
      if (allLink) {
        allLink.hidden = false;
        allLink.href = (allLink.getAttribute('data-base') || '/search') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
        var label = allLink.querySelector('[data-dm-search-all-q]');
        if (label) label.textContent = q;
      }
    }

    function run() {
      var q = input.value.trim();
      if (q === lastQuery) return;
      lastQuery = q;
      clearTimeout(timer);
      if (q.length < 2) {
        results.hidden = true;
        if (idle) idle.hidden = false;
        if (allLink) allLink.hidden = true;
        return;
      }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = 'AbortController' in window ? new AbortController() : null;
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources%5Btype%5D=product,collection,page,article&resources%5Blimit%5D=6&resources%5Boptions%5D%5Bunavailable_products%5D=last';
        fetch(url, controller ? { signal: controller.signal } : {})
          .then(function (res) { return res.json(); })
          .then(function (data) { if (input.value.trim() === q) render(data, q); })
          .catch(function (err) { if (err && err.name !== 'AbortError' && input.value.trim() === q) render({}, q); });
      }, 200);
    }
    input.addEventListener('input', run);
  }

  /* ---------------- recent cars ---------------- */
  function initCars(labels) {
    var pages = carPages();
    var path = window.location.pathname.replace(/\/$/, '');
    var now = Date.now();
    var today = new Date().toISOString().slice(0, 10);
    var list = readCars().filter(function (c) {
      return c && c.u && now - (c.at || 0) < 180 * 864e5 && pages.some(function (p) { return p.u === c.u; });
    });
    var match = null;
    for (var i = 0; i < pages.length; i++) {
      if (pages[i].u.replace(/\/$/, '') === path) { match = pages[i]; break; }
    }
    if (match) {
      var existing = list.filter(function (c) { return c.u === match.u; })[0];
      var days = existing && existing.d ? existing.d : [];
      if (days.indexOf(today) === -1) days = days.concat(today).slice(-5);
      list = [{ t: match.t, u: match.u, d: days, at: now }].concat(list.filter(function (c) { return c.u !== match.u; })).slice(0, 3);
    }
    writeCars(list);
    render(list);

    function render(cars) {
      var mine = cars[0];
      $all('[data-dm-my-car]').forEach(function (el) {
        if (!mine) { el.hidden = true; return; }
        var link = el.querySelector('a') || el;
        link.setAttribute('href', mine.u);
        var label = el.querySelector('[data-dm-my-car-label]');
        if (label) label.textContent = mine.t;
        var pre = el.querySelector('[data-dm-my-car-pre]');
        if (pre) pre.textContent = mine.d && mine.d.length > 1 ? labels.your : labels.last;
        el.hidden = false;
      });
      $all('[data-dm-recent-cars]').forEach(function (box) {
        var holder = box.querySelector('[data-dm-recent-list]');
        if (!cars.length || !holder) { box.hidden = true; return; }
        holder.innerHTML = cars.map(function (c) { return '<a class="dm-cars__recent-pill" href="' + escapeHtml(c.u) + '">' + escapeHtml(c.t) + '</a>'; }).join('');
        box.hidden = false;
      });
      var fam = mine && pages.filter(function (p) { return p.u === mine.u; })[0];
      if (fam && fam.f) {
        $all('[data-dm-cars]').forEach(function (panel) { if (panel.__dmSelectFamily) panel.__dmSelectFamily(fam.f); });
      }
      var urls = cars.map(function (c) { return c.u; });
      $all('[data-dm-car-link]').forEach(function (a) {
        a.classList.toggle('is-mine', urls.indexOf(a.getAttribute('href')) !== -1);
      });
    }
    $all('[data-dm-my-car-clear]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var rest = readCars().slice(1);
        writeCars(rest);
        render(rest);
      });
    });
  }

  /* The theme writes "0" into count bubbles; hide them at zero. */
  function initCounts() {
    var counts = $all('.dm-hdr [data-cart-count], .dm-hdr [data-wishlist-count], .dm-hdr__navrow [data-cart-count]');
    function sync(el) {
      var n = parseInt(String(el.textContent).replace(/[^0-9]/g, ''), 10);
      if (!n) el.setAttribute('data-empty', ''); else el.removeAttribute('data-empty');
    }
    counts.forEach(function (el) {
      sync(el);
      if ('MutationObserver' in window) new MutationObserver(function () { sync(el); }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  function boot() {
    var header = $('[data-dm-header]');
    if (!header || header.__dm) return;
    header.__dm = true;
    var navrow = $('[data-dm-navrow]');
    initSticky(header, navrow);
    initMega(navrow);
    initMega($('[data-dm-top]'));
    initCarPanels();
    initDrawer();
    initSearch();
    initCounts();
    initCars({
      last: header.getAttribute('data-last-car') || 'Last viewed:',
      your: header.getAttribute('data-your-car') || 'Your'
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () {
    var header = $('[data-dm-header]');
    if (header) header.__dm = false;
    boot();
  });
})();
